<template>
    <textarea :placeholder='translate("enter_query")'
              v-model="value">
    </textarea>
</template>

<script>
    export default {
        name: "AreaCustomQuestion",
        props: ['name'],
        data() {
            return {
                value: ''
            }
        },

        methods: {
            emitValidateData() {
                this.$parent.$emit('validateData', {
                    inputName: this.name,
                    value: this.value
                });
            },

            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                };

                this.$store.commit(arg);

                return arg.out;
            },
        },

        mounted() {
            this.$parent.$on('getValidateData', () => {
                this.emitValidateData();
            });
        }
    }
</script>